module.exports = __webpack_public_path__ + "static/img/rankboardClick-EN.ec3a99e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/rankboardClick-EN.png
// module id = 02Gt
// module chunks = 1